import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PageShell from "@/components/PageShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import PasswordInput from "@/components/PasswordInput";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("هذا الحساب ليس حساب مشرف");
        setLoading(false);
        return;
      }
      toast.success("تم تسجيل الدخول كمشرف");
      navigate("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "بيانات غير صحيحة");
      setLoading(false);
    }
  };

  return (
    <PageShell>
      <section className="max-w-md mx-auto px-6 py-16">
        <div className="card-warm p-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#F6F4EE] grid place-items-center">
              <ShieldCheck className="w-5 h-5 text-[#0A4D3C]" />
            </div>
            <h1 className="font-heading text-3xl text-[#222222]">دخول المشرفة</h1>
          </div>
          <p className="text-[#5E5C58] text-sm mt-3">
            هذه الصفحة مخصّصة للمشرفة لإدارة الحجوزات والتوافر والكتاب الرقمي.
          </p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">البريد الإلكتروني</Label>
              <Input
                id="email"
                data-testid="admin-login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2"
                dir="ltr"
              />
            </div>
            <div>
              <Label htmlFor="password">كلمة المرور</Label>
              <PasswordInput
                id="password"
                data-testid="admin-login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2"
              />
            </div>
            <Button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-[#0A4D3C] hover:bg-[#063A2D] text-white h-11"
            >
              {loading ? "جاري الدخول..." : "دخول"}
            </Button>
          </form>
        </div>
      </section>
    </PageShell>
  );
};

export default AdminLogin;
